import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
export function Accordion({ id, children, className }) {
    return (_jsx("div", { id: id, className: className !== null && className !== void 0 ? className : "accordion", children: children }));
}
export function AccordionItemTemplate({ icon, title, additionalInfo, uuid, children, open, }) {
    const detailsRef = useRef(null);
    const [isOpen, setIsOpen] = useState(open !== null && open !== void 0 ? open : false);
    useEffect(() => {
        // Check if the URL hash targets this accordion directly, or an element inside it.
        // With <details>, children are always in the DOM even when closed, so getElementById works.
        const hash = globalThis.location.hash;
        if (!hash || !uuid || !detailsRef.current)
            return;
        const targetId = hash.slice(1);
        const isDirectMatch = targetId === uuid;
        const targetElement = document.getElementById(targetId);
        const isChildMatch = targetElement !== null && detailsRef.current.contains(targetElement);
        if (isDirectMatch || isChildMatch) {
            // Open the <details> element directly via the DOM to avoid a cascading React re-render.
            // This triggers a native 'toggle' event, which the onToggle handler catches to sync React state.
            detailsRef.current.open = true;
            requestAnimationFrame(() => {
                const scrollTarget = isDirectMatch ? detailsRef.current : targetElement;
                scrollTarget === null || scrollTarget === void 0 ? void 0 : scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
            });
        }
    }, [uuid]);
    return (_jsxs("details", { ref: detailsRef, id: uuid, onToggle: (event) => {
            setIsOpen(event.currentTarget.open);
        }, open: isOpen, "aria-labelledby": uuid + "-button", children: [_jsx("summary", { children: _jsxs("div", { id: uuid + "-button", children: [icon && _jsx("span", { children: icon }), _jsxs("div", { children: [_jsx("h3", { children: title }), _jsx("span", { children: additionalInfo })] }), isOpen ? _jsx(FontAwesomeIcon, { icon: faChevronUp }) : _jsx(FontAwesomeIcon, { icon: faChevronDown })] }) }), _jsx("div", { className: "accordion-panel", children: children })] }));
}
